<template>
  <div class="retrieve-description-book">
    <div v-for="(descriptionItem, index) in descriptionItemList"
         :key="index"
         class="description-item">
      <img class="image"
           :src="descriptionItem.image">
      <div class="title">{{descriptionItem.title}}</div>
      <div class="colon">：</div>
      <div class="value">{{descriptionItem.value}}</div>
    </div>
  </div>
</template>

<script>
import { convertTraditionalStatus } from '@/utils/s_t_convert.js'
export default {
  name: 'RetrieveDescriptionBook',
  props: {
    bookId: {
      type: Number,
      required: true
    },
    traditional: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      descriptionItemList: [
        {
          image: 'static/images/bookIcons/bookid.png',
          title: '书籍ID',
          value: ''
        },
        {
          image: 'static/images/bookIcons/bookname.png',
          title: '书名',
          value: ''
        },
        {
          image: 'static/images/bookIcons/classification.png',
          title: '分类',
          value: ''
        },
        {
          image: 'static/images/bookIcons/author.png',
          title: '著者',
          value: ''
        },
        {
          image: 'static/images/bookIcons/bookversion.png',
          title: '版本',
          value: ''
        },
        {
          image: 'static/images/bookIcons/place.png',
          title: '馆藏地',
          value: ''
        },
        {
          image: 'static/images/bookIcons/content.png',
          title: '内容提要',
          value: ''
        },
        {
          image: 'static/images/bookIcons/bookcharacteristic.png',
          title: '书籍特征',
          value: ''
        },
        {
          image: 'static/images/bookIcons/createyear.png',
          title: '成书年',
          value: ''
        },
        {
          image: 'static/images/bookIcons/image.png',
          title: '图片数量',
          value: ''
        }
      ]
    }
  },
  watch: {
    tabIndex () {
      this.rebuildViewer()
    },
    bookId () {
      this.getBookInfo()
    },
    traditional () {
      console.log('traditional', this.traditional)
      convertTraditionalStatus(['.retrieve-description-book'], this.traditional)
    }
  },
  mounted () {
    this.getBookInfo()
  },
  methods: {
    getBookInfo () {
      const params = new URLSearchParams()
      const url = 'retrieve/book/getBookInfo'
      params.append('bookId', this.bookId)
      this.$http.post(url, params).then((res) => {
        // console.log(res)
        if (res.data.status === 200 && res.status === 200) {
          this.$nextTick(() => { this.$emit('get-book-info') })
          var info = res.data.data
          //   var metaData = JSON.parse(res.data.data.meta)
          console.log('info', info)
          this.descriptionItemList.forEach((item) => {
            switch (item.title) {
              case '图片数量':
                item.value = info.text.length
                break
              case '书籍ID':
                item.value = this.bookId
                break
              case '书名':
                item.value = info.bookName
                break
              case '分类':
                item.value = info.classification
                break
              case '著者':
                item.value = info.authorDetail
                break
              case '版本':
                item.value = info.edition
                break
              case '馆藏地':
                item.value = info.library
                break
              case '内容提要':
                item.value = info.description
                break
              case '书籍特征':
                item.value = info.feature
                break
              case '成书年':
                item.value = info.completionTime
                break
              default:
                break
            }
          })
          this.$nextTick(() => {
            convertTraditionalStatus(['retrieve-description-book'], this.traditional)
          })
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
          console.log(res)
        }
      })
    }
  }
}
</script>

<style scoped>
* {
  color: #634c37;
  font-size: 16px;
}

.retrieve-description-book {
  padding: 51px 61px 0px 55px;
}

.description-item {
  display: flex;
  margin-bottom: 22px;
}

.image {
  height: 18px;
  width: 18px;
  margin-right: 7px;
  margin-top: 4px;
}

.title {
  margin-right: 1px;
  width: 64px;
  height: 16px;
  text-align-last: justify;
  font-weight: bold;
}

.colon {
  margin-right: 14px;
  width: 16px;
  height: 16px;
}

.value {
  text-align: left;
  flex-grow: 1;
  width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveDescriptionBook.vue